import { render, staticRenderFns } from "./DeadlineMonitoringTabScheduledRenewals.vue?vue&type=template&id=fb0d5c44"
import script from "./DeadlineMonitoringTabScheduledRenewals.vue?vue&type=script&lang=js"
export * from "./DeadlineMonitoringTabScheduledRenewals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports